import { MenuItem } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
    ControlledNumberInput,
    ControlledSelect,
    FormGrid,
    MultipleSelectComponent,
    Section,
    useSupportTypes,
} from '../../../shared';

export const OrganisationSettingInputs = () => {
    const { t } = useTranslation();
    const supportTypes = useSupportTypes();

    const { watch } = useFormContext();
    const watchSupportTypes = watch('supportTypes');

    return (
        <Section title={t('settings')}>
            <FormGrid size={{ xs: 3 }}>
                <MultipleSelectComponent
                    name={'supportTypes'}
                    label={t('supportTypes')}
                    items={supportTypes.map((supportType) => ({
                        id: supportType.id as string,
                        name: supportType.name,
                    }))}
                />
                <ControlledSelect
                    name="defaultSupportTypeId"
                    label={t('defaultSupportType')}
                    required={watchSupportTypes?.length > 1}
                >
                    <MenuItem value="" sx={{ height: '35px' }} />
                    {supportTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                            {type.name}
                        </MenuItem>
                    ))}
                </ControlledSelect>
                <ControlledNumberInput name="defaultSupportPeriod" label={t('defaultSupportPeriod')} required />
            </FormGrid>
        </Section>
    );
};
